function DashboardPage({ stats, openPost, goAdmin }) {
  const metricTiles = [
    { label: "Total Blogs", value: stats.totalBlogs },
    { label: "Total Likes", value: stats.totalLikes },
    { label: "Total Dislikes", value: stats.totalDislikes },
    { label: "Blogs This Month", value: stats.blogsThisMonth },
    { label: "Active Categories", value: stats.activeCategories },
    { label: "Avg Words / Post", value: stats.avgWordsPerPost },
    { label: "Posts / Month", value: stats.frequencyPerMonth },
    { label: "Avg Days Between Posts", value: stats.avgDaysBetweenPosts || "-" },
    { label: "Unique Visitors", value: stats.uniqueVisitors },
    { label: "Total Sessions", value: stats.totalSessions },
    { label: "Page Views", value: stats.pageViews },
    { label: "Engagement", value: `${stats.engagementRate}%` },
    { label: "Retention", value: `${stats.retentionRate}%` },
    { label: "Session Depth", value: stats.avgSessionDepth },
  ];

  return (
    <main className="main dashboard-main">
      <div className="dashboard-decor" aria-hidden="true">
        <span className="orb orb-a" />
        <span className="orb orb-b" />
        <span className="orb orb-c" />
      </div>
      <div className="dashboard-side-doodles" aria-hidden="true">
        <svg className="dash-doodle dash-doodle-a" viewBox="0 0 46 46" role="img">
          <rect x="7" y="7" width="32" height="32" rx="10" fill="#9cd2f3" />
          <path d="M14 17h18M14 23h12M14 29h8" stroke="#2e78ae" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
        <svg className="dash-doodle dash-doodle-b" viewBox="0 0 46 46" role="img">
          <circle cx="23" cy="23" r="17" fill="#bce4fb" />
          <circle cx="18" cy="19" r="2.5" fill="#2d74a8" />
          <circle cx="28" cy="19" r="2.5" fill="#2d74a8" />
          <path d="M16 27c2.7 3.4 11.3 3.4 14 0" stroke="#2d74a8" strokeWidth="2" fill="none" strokeLinecap="round" />
        </svg>
        <svg className="dash-doodle dash-doodle-c" viewBox="0 0 46 46" role="img">
          <path d="M23 5l4.1 8.4 9.3 1.4-6.7 6.4 1.6 9.2-8.3-4.4-8.3 4.4 1.6-9.2-6.7-6.4 9.3-1.4z" fill="#ffd9a5" />
        </svg>
      </div>

      <section className="dashboard-hero">
        <div>
          <p className="dashboard-kicker">Admin Analytics</p>
          <h1>Portfolio Blog Dashboard</h1>
          <p>
            A single glass-style report surface for blog publishing velocity, reader activity,
            engagement quality, and retention trends.
          </p>
        </div>
        <button className="btn-secondary" type="button" onClick={goAdmin}>
          Create Blog
        </button>
      </section>

      <section className="dashboard-grid">
        {metricTiles.map((metric, index) => (
          <article
            className="dashboard-tile"
            key={metric.label}
            style={{ animationDelay: `${index * 70}ms` }}
          >
            <p>{metric.label}</p>
            <h3>{metric.value}</h3>
          </article>
        ))}
      </section>

      <section className="dashboard-panels">
        <article className="dashboard-panel">
          <h2>Top Categories</h2>
          {stats.topCategories.length ? (
            <ul>
              {stats.topCategories.map(([name, count]) => (
                <li key={name}>
                  <span>{`#${name}`}</span>
                  <strong>{count}</strong>
                </li>
              ))}
            </ul>
          ) : (
            <p>No category data yet.</p>
          )}
        </article>

        <article className="dashboard-panel">
          <h2>Top Reacted Posts</h2>
          {stats.mostLikedPosts.length ? (
            <ul>
              {stats.mostLikedPosts.map((post) => (
                <li key={post.id}>
                  <button type="button" onClick={() => openPost(post.id)}>
                    <span>{post.title}</span>
                    <small>{`${post.likes} likes | ${post.dislikes} dislikes`}</small>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p>No reaction data yet.</p>
          )}
        </article>

        <article className="dashboard-panel">
          <h2>Recent Posts</h2>
          {stats.recentPosts.length ? (
            <ul>
              {stats.recentPosts.map((post) => (
                <li key={post.id}>
                  <button type="button" onClick={() => openPost(post.id)}>
                    <span>{post.title}</span>
                    <small>{post.date}</small>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p>No posts yet.</p>
          )}
        </article>
      </section>
    </main>
  );
}

export default DashboardPage;
